
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import dentistDataService from "./dentistService";




const initialState = {
    dentists: [],
    isError: false,
    isLoading: false,
    isSuccess: false,
    message: "",
}

export const getdentist = createAsyncThunk("dentists", async (thunkAPI) => {
    try {
        return await dentistDataService.dentistData();
    } catch (err) {
        const message = (
            err.response && err.response.data && err.response.data.message
        ) || err.message || err.toString();
        return thunkAPI.rejectWithValue(message)
    }
})

export const dentistDataSlice = createSlice({
    name: "dentists",
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = false;
            state.message = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(
                getdentist.pending, (state) => {
                    state.isLoading = true
                }

            )
            .addCase(
                getdentist.fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.isSuccess = true;
                    state.dentists = action.payload;

                }
            )
            .addCase(
                getdentist.rejected, (state, action) => {
                    state.isLoading = false;
                    state.isError = true;
                    state.message = action.payload;
                    state.dentists = null
                }
            )
    }
})

export const { reset } = dentistDataSlice.actions;
export default dentistDataSlice.reducer;